import React, { Component } from 'react';
import BaseBtn from '../../Buttons/BaseBtn';

class PopupAlert extends Component {
    /*state = {
        visible: false
    }*/

    constructor(props) {
        super(props);
        this.state = {
            visible: props.active
        };
    }
    
    componentWillReceiveProps = (nextProps) => {
    	this.setState({
    		visible: nextProps.active
    	});
    }

    closePopup = () => {
    	const {mode, onCancel} = this.props;

        if (this.state.visible) {
            this.setState({
                visible: false
            })
        }

        onCancel();
    }

    cancel = () => {
		const {onCancel} = this.props;

		onCancel();

    }

    confirm = () => {
    	const {onConfirm, mode} = this.props;

    	onConfirm();

    	if(mode == 0) {
    		this.closePopup();
    	}
    }

    render() {
        return (
            this.state.visible?

            <div className="popupWrapper">
                <div className="popup">
                    <div className="alertWrapper">
                        <dl className="alert">
                            <dt className="title">
                                <span>알림</span>
                                <button onClick={this.closePopup} className="btnClose">닫기</button>
                            </dt>
                            <dd className="contents">
                                <div>

                                    <div className="desc">
                                        <span>{this.props.message}</span>
                                    </div>

                                    {/*<div className="desc">*/}
                                        {/*<a class="baseBtn blue" href="/app"><span>엑셀파일 업로드</span></a>*/}
                                        {/*<a class="baseBtn blue" href="/app"><span>파일 업로드</span></a>*/}
                                    {/*</div>*/}

                                    {/*<div className="desc">*/}
                                      {/*<span>정말로 삭제하시겠습니까?</span>*/}
                                    {/*</div>*/}

                                    {(this.props.link == '')? 
                                	    <BaseBtn btnColor="deepPink" btnName={this.props.confirmName} onClick={this.confirm}/> :
                                	    <BaseBtn btnColor="deepPink" link={this.props.link} btnName={this.props.confirmName} onClick={this.confirm}/>}
                                    {(this.props.mode == 1) && <BaseBtn btnColor="deepPink" btnName={this.props.cancelName} onClick={this.cancel}/>}
                                </div>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>

            : null
        );
    }
}

PopupAlert.defaultProps = {
		active: true,
		link: '',
		mode: 0, // 0:confirm, 1:question
		onConfirm: ()=>{},
		onCancel: ()=>{},
		confirmName: "확인",
		cancelName: "취소"

}

export default PopupAlert;



// WEBPACK FOOTER //
// ./src/components/Containers/PopupAlert/index.js